import { produce } from 'immer'
import reducerUtils from './reducerUtils'

/**
 * Generic server-state slice. Each resource is stored under a key (e.g. 'customers',
 * 'application:<id>') as { loading, error, value }. Built on reducerUtils like every other slice.
 */
export const DataActions = {
  LOADING: 'data/loading',
  LOADED: 'data/loaded',
  FAILED: 'data/failed',
  RESET: 'data/reset',
}

export const dataSelectors = {
  get: (key) => (s) => s.data[key] || { loading: false, error: null, value: null },
}

const entry = (draft, key) => {
  if (!draft[key]) draft[key] = { loading: false, error: null, value: null }
  return draft[key]
}

const handlers = {
  [DataActions.LOADING]: produce((draft, a) => {
    const e = entry(draft, a.key)
    e.loading = true
    e.error = null
  }),
  [DataActions.LOADED]: produce((draft, a) => {
    const e = entry(draft, a.key)
    e.loading = false
    e.value = a.value
  }),
  [DataActions.FAILED]: produce((draft, a) => {
    const e = entry(draft, a.key)
    e.loading = false
    e.error = a.error
  }),
  [DataActions.RESET]: () => ({}),
}

export default reducerUtils.createReducer({}, handlers)
